const LOCAL_STORAGE_IS_ONBOARDING_KEY = 'isOnboarding'
const LOCAL_STORAGE_IS_ONBOARDING_VALUE = 'true'

export const recordShouldResumeOnboardingAfterOauthRedirection = () => {
  localStorage.setItem(
    LOCAL_STORAGE_IS_ONBOARDING_KEY,
    LOCAL_STORAGE_IS_ONBOARDING_VALUE
  )
}

export const clearShouldResumeOnboardingAfterOauthRedirection = () => {
  localStorage.removeItem(LOCAL_STORAGE_IS_ONBOARDING_KEY)
}

export const getShouldResumeOnboardingAfterOauthRedirection = (): boolean =>
  !!localStorage.getItem(LOCAL_STORAGE_IS_ONBOARDING_KEY)
